<div class="container">
  <div class="card-filter">
    <div class="row">
      <div class="col">
        <button class="btn btn-sm btn-apply" (click)="submit()" data-bs-dismiss="modal">
          <i class="fal fa-check pr-2 align-middle"></i><span class="align-middle">APLICAR</span>
        </button>

        <mat-checkbox class="select-all" aria-label="Select All"  [checked]="allSelected" [indeterminate]="indeterminate"
          (change)="toggleSelectAll($event)">
          <span class="font">SELECIONAR TODOS</span>
        </mat-checkbox>
      </div>

      <div class="col-auto clear-all">
        <button type="button" class="btn btn-trasparent clear-button" (click)="clear()">
          <i class="fal fa-trash-alt clear-icon fa-lg me-2"></i>
          <span class="font-bold">LIMPAR</span>
        </button>
      </div>
    </div>


    <div class="search">
      <div class="row">
        <div class="col-12">
          <mat-form-field>
<!--            <input matInput placeholder="Empresa..." (keyup)="onSearch()" [(ngModel)]="searchTem" />-->
            <input matInput placeholder="Empresa..." #companySearchInput [(ngModel)]="searchInput" />
            <mat-icon matSuffix>search</mat-icon>
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="btn-default">
      <div *ngIf="!existsCompanyAll">
        <a (click)="fetchAllCompanys('yes')">Buscar todas as empresas <i class="fal fa-angle-down icon"></i></a>
      </div>

      <div *ngIf="existsCompanyAll">
        <a (click)="fetchAllCompanys('no')"><i class="fal fa-angle-left icon"></i>Voltar para empresas escolhidas</a>
      </div>
    </div>

    <div class="row mt-3" *ngIf="filter && existsCompany">
      <div class="col-12">
        <div class="row list-companies">
          <app-checkbox-store  attrFilterState="companies" attrLabel="companyName" [state]="filter"
            (onChangeCheckbox)="onChangeCheckbox($event)"></app-checkbox-store>
        </div>
      </div>
    </div>

    <div class="checkbox-text-side" *ngIf="!existsCompany">
          <span>Nenhuma empresa encontrada para sua busca.</span>
    </div>
  </div>
</div>
